import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
      lightboxUrl: null,
      firebase: null
    },
    mutations: {
      setLightboxImage (state, url) {
        if(typeof url !== "string" && url !== null) {
            return;
        }

        this.state.lightboxUrl = url;
      },
      setFirebase (state, firebase) {
        this.state.firebase = firebase;
      }
    },
    getters: {
        getLightboxImage: state => state.lightboxUrl,
        firebase: state => state.firebase
    }
})

export default store;